import useCapabilities, {
  DOMAIN,
  PERMISSION,
  useHasCapabilityBool,
  useRequireCapability
} from "@/hooks/useCapabilities";

export function usePersonContactAccess() {
  const { loaded } = useCapabilities();
  const canViewPersonContact = useHasCapabilityBool({
    domain: DOMAIN.PEOPLE,
    permission: PERMISSION.viewPersonContact
  });

  useRequireCapability({ domain: DOMAIN.PEOPLE, permission: PERMISSION.viewPersonContact });

  return {
    loaded,
    canViewPersonContact
  };
}
